import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'app/types';

import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.softwareInventory || initialState;

export const selectSoftwareInventory = createSelector(
  [selectDomain],
  softwareInventoryState => softwareInventoryState,
);
